import { cva } from 'class-variance-authority';
import { ElementIntent } from '../../enums';
export const alertStyling = cva('flex gap-3 items-start p-4 rounded-2xl text-sm ring-1 ring-offset-2', {
    variants: {
        intent: {
            [ElementIntent.Info]: 'bg-neutral-50 ring-neutral-100',
            [ElementIntent.Success]: 'bg-green-50 ring-green-100',
            [ElementIntent.Warning]: 'bg-yellow-50 ring-yellow-100',
            [ElementIntent.Danger]: 'bg-rose-50 ring-rose-100',
        },
    },
    defaultVariants: {
        intent: ElementIntent.Info,
    },
});
export const alertIconStyling = cva('flex rounded-full size-6 mt-1', {
    variants: {
        intent: {
            [ElementIntent.Info]: 'text-neutral-400',
            [ElementIntent.Success]: 'text-green-400',
            [ElementIntent.Warning]: 'text-white bg-yellow-400',
            [ElementIntent.Danger]: 'text-rose-400',
        },
    },
    defaultVariants: {
        intent: ElementIntent.Info,
    },
});
